import { create } from 'zustand';
import type { Usuario } from '../../api-client/usuarios/usuario';
import {
  actualizarUsuario,
  desactivarUsuario,
  obtenerUsuarioPorId,
  obtenerUsuariosPaginados,
  registrarUsuario,
  type ActualizarUsuarioRequest,
  type RegistrarUsuarioRequest
} from '../../api-client/usuarios/usuarios.api';
import type { PaginatedList } from '../common/padinated-list';
import type { PaginationQueryParamsWithStatus } from '../common/pagination-query-params';
import { useUIStore } from '../ui/ui.store';

export interface UsuariosState {
  list: PaginatedList<Usuario>;
  current: Usuario;
  actives: Usuario[];

  nuevo: () => void;
  cargarPaginados: (params: PaginationQueryParamsWithStatus) => Promise<void>;
  cargarPorId: (id: string) => Promise<void>;
  registrar: (request: RegistrarUsuarioRequest) => Promise<boolean>;
  actualizar: (id: string, request: ActualizarUsuarioRequest) => Promise<boolean>;
  desactivar: (id: string) => Promise<boolean>;
}

const { showSuccessToast } = useUIStore.getState();

export const useUsuariosStore = create<UsuariosState>()((set, get) => ({
  list: {
    items: [],
    pageIndex: 0,
    pageSize: 10,
    totalRows: 0
  },
  current: {} as Usuario,
  actives: [],

  nuevo: () =>
    set({
      current: {} as Usuario
    }),
  cargarPaginados: async (params: PaginationQueryParamsWithStatus) => {
    const response = await obtenerUsuariosPaginados(params);

    if (response.isFailure) return;

    set({
      list: response.result
    });
  },
  cargarPorId: async (id: string) => {
    const response = await obtenerUsuarioPorId(id);

    if (response.isFailure) return;

    set({
      current: response.result
    });
  },
  registrar: async (request: RegistrarUsuarioRequest) => {
    const response = await registrarUsuario(request);

    if (response.isFailure) return false;

    showSuccessToast('Usuario registrado exitosamente');
    return true;
  },
  actualizar: async (id: string, request: ActualizarUsuarioRequest) => {
    const response = await actualizarUsuario(id, request);

    if (response.isFailure) return false;

    showSuccessToast('Usuario actualizado exitosamente');

    set({
      current: {
        ...get().current,
        ...request
      }
    });

    return true;
  },
  desactivar: async (id: string) => {
    const response = await desactivarUsuario(id);

    if (response.isFailure) return false;

    showSuccessToast('Usuario desactivado exitosamente');

    set({
      current: {
        ...get().current,
        activo: false
      }
    });

    return true;
  }
}));
